import React from 'react'
import PropTypes from 'prop-types'
import { Div } from 'glamorous'

import Text from 'components/common/Text'

export default class StoredDataItem extends React.PureComponent {
  static propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.node
  }

  render() {
    return (
      <Div
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        padding={16}
        borderBottom="1px solid #dbdce0"
      >
        <Div><Text size={18}>{this.props.title}</Text></Div>
        <Div><Text size={18} color="grey">{this.props.children || '-'}</Text></Div>
      </Div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/profile/StoredDataItem.js